import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import { compose } from 'redux';
import Error from '../../components/Error';

class ErrorPage extends Component {
    
    render() {
        const { t } = this.props;
        const errorCode = this.props.errorCode;
        return (
            <Error number={errorCode} text={t("error.subTitle404")}/>
        );
    }
}

export default compose(
    withTranslation()
)(ErrorPage);
